import { render, staticRenderFns } from "./selectedTags.vue?vue&type=template&id=1fb85b67&scoped=true"
import script from "./selectedTags.vue?vue&type=script&lang=js"
export * from "./selectedTags.vue?vue&type=script&lang=js"
import style0 from "./selectedTags.vue?vue&type=style&index=0&id=1fb85b67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb85b67",
  null
  
)

export default component.exports